module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAAXNSR0IArs4c6QAAABhQTFRFAAAAMDAwNDQ0MTExMjIyMjIyMjIyMzMzcjXilAAAAAd0Uk5TADs7d3t/8893TaoAAACPSURBVEjH7dMxDoAgDAVQ0Lg7OTNxDjdXN2dZOICRXl8ChFSkdTWGvzX9eVMrREvLb9OPeOrmR2Hb8aTPcj+AQ0RnYS0KCwAiNMBRFCZAhAfAFAVpEeEBpwRN1IAbUQUQUQcQQQCZoIBMkEAiaCARDBAJBogEBwSCAyLBAYEw7OFJywOeMC+3K1X735aP5wISCzV0YkKsEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/arrow_down.png
// module id = 6k67
// module chunks = 6